import { Wrapper, Container } from './PianoPleaContainerStyles';

const PianoPleaContainer = ({ className }: { className?: string }) => {
  // const trackingData = {
  //   contentPlacementCD: 'hero+1',
  //   eventAction: title,
  //   eventCategory: 'navigation',
  //   eventLabel: text,
  // };

  return (
    <Wrapper
      data-cy='piano-plea-container'
      className={className}
    >
      <Container id='hp-piano-template-plea-container'></Container>
    </Wrapper>
  );
};

export default PianoPleaContainer;
